module.exports = __webpack_public_path__ + "files/213df11b2b8d8471bfbbde98c88e5302.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people_body-5.png
// module id = 504
// module chunks = 76